



























import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Throttle from '@/misc/Throttle';

const MagazineStore = namespace('magazine');
const ApplicationStore = namespace('application');

@Component({})
export default class SearchBarComponent extends Vue {

    @MagazineStore.Action('applyFilterSearchText')
    public applyFilterSearchText!: (searchText: string) => void;

    @ApplicationStore.Getter('noAnimations')
    public noAnimations!: boolean;

    /**
     *  Throttle to limit filter applications
     */
    public throttle: Throttle;

    public showMagazineSearch = false;

    public searchValue: string = '';

    get searchInputElement(): HTMLInputElement {
        return this.$refs['search-input'] as Vue & HTMLInputElement;
    }

    constructor() {
        super();
        this.throttle = new Throttle();
    }

    public onActionButtonClicked() {
        this.searchInputElement.focus();
        this.searchValue = '';
        this.showMagazineSearch = !this.showMagazineSearch;
        this.$emit('showMagazineSearch', this.showMagazineSearch);
    }

    public beforeDestroy() {
        // reset everything
        this.searchValue = '';
        this.showMagazineSearch = false;
        this.$emit('showMagazineSearch', this.showMagazineSearch);
        this.applyFilterSearchText('');
    }

    /**
     * Event handler for text input
     */
    public onSearchTextInput(event: string) {
        this.throttle.throttle(() => this.applyFilterSearchText(event ?? ''));
    }
};
